import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { catchError, map, of, timeout } from 'rxjs'
import { SystemStatusService } from './system-status.service'

// every app entry waits for the status so a slow endpoint must not block it for long
const STATUS_TIMEOUT_MS = 5_000

export const isPortalOpen: CanActivateFn = (_route, state) => {
  const maintenancePage = inject(Router).createUrlTree(['/maintenance'], { queryParams: { returnUrl: state.url } })

  return inject(SystemStatusService)
    .getStatus()
    .pipe(
      map(({ status }) => (status === 'ONLINE' ? true : maintenancePage)),
      timeout(STATUS_TIMEOUT_MS),
      // let users in when the status is slow or unreachable because the interceptor still catches a closed api
      catchError(() => of(true))
    )
}
